import _ from 'lodash';

const analyticsTypes = {
  LOYALTY_LIST_PROGRAMS: 'loyalty_ListPrograms',
  LOYALTY_VIEW_PROGRAM: 'loyalty_ViewProgram',
  LOYALTY_VIEW_TAB: 'loyalty_Details_tab',
  LOYALTY_SEARCH_ITEM_GOAL_VIEW: 'loyalty_SearchItem_Goal_View',
  LOYALTY_SEARCH_HOVER: 'loyalty_SearchItem_Hover_Details',
  LOYALTY_SEARCH_CLICK: 'loyalty_SearchItem_Click_Details'
};

const extractItemProgramDetails = (item, program, extra) => ({
  item_id: _.get(item, 'id'),
  program_id: _.get(item, 'relevant_program.program_id'),
  program_goal_id: _.get(item, 'relevant_program.program_goal_id'),
  vendor_id: _.get(program, 'vendor.id'),
  ...extra
});

const extractProgramDetails = (program, extra) => ({
  program_id: _.get(program, 'id'),
  program_name: _.get(program, 'name'),
  vendor_id: _.get(program, 'vendor.id'),
  ...extra
});

const analyticsActions = [{
  type: analyticsTypes.LOYALTY_LIST_PROGRAMS
}, {
  type: analyticsTypes.LOYALTY_VIEW_PROGRAM,
  attributesExtractor: extractProgramDetails
}, {
  type: analyticsTypes.LOYALTY_SEARCH_ITEM_GOAL_VIEW,
  attributesExtractor: extractItemProgramDetails
}, {
  type: analyticsTypes.LOYALTY_VIEW_TAB,
  attributesExtractor: extractProgramDetails
}, {
  type: analyticsTypes.LOYALTY_SEARCH_HOVER,
  attributesExtractor: extractItemProgramDetails
}, {
  type: analyticsTypes.LOYALTY_SEARCH_CLICK,
  attributesExtractor: extractItemProgramDetails
}];

export {
  analyticsTypes,
  analyticsActions
};
